export const ActionTypes = {
  DISMISS_TOP_BANNER: 'appMigration/dismiss_top_banner',
};

export const dismissAppMigrationTopBanner = () => ({
  type: ActionTypes.DISMISS_TOP_BANNER,
});
